export default __webpack_public_path__ + "static/media/TermsOfServiceTemplate.01f4175a.md";